// extracted by mini-css-extract-plugin
export default {"page":"uHskMddHILPmEjbHfyqE","body":"HNFs83B_i7tUagnKh2c8","page_wrap":"ROJs8qWg6h48G30BvvyO","pageWrap":"ROJs8qWg6h48G30BvvyO"};